// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDayOfYear as fn } from "../getDayOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDayOfYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getDayOfYear;
